import { normalizeProtocolRelativeImageUrl, optimizeContentfulImageUrl } from './imageUrl';

type LoaderArgs = {
  src: string;
  width: number;
  quality?: number;
};

export const normalizeNextImageSrc = normalizeProtocolRelativeImageUrl;

export default function nextImageLoader({ src, width, quality }: LoaderArgs): string {
  return optimizeContentfulImageUrl(src, { width, quality });
}
